import { ReactNode } from 'react'

import useCurrentUser from '@hooks/useCurrentUser'

interface ScopedConditionalContentProps {
  children: ReactNode,
  permittedRoleTitles: string[],
  visible?: true | false | undefined,
}

const ScopedConditionalContent = (props: ScopedConditionalContentProps) => {
  const { children, permittedRoleTitles, visible = true } = props

  const { roleTitle } = useCurrentUser()

  const isPermitted = permittedRoleTitles.includes(roleTitle) && visible

  if (!isPermitted) return null

  return children
}

export default ScopedConditionalContent
